import React, { Component } from "react";
import { Link } from "react-router-dom";
import "animate.css";

import Navbar from "../../Navbar/Navbar";
import MainBodyContainer from "../../Common/Body/MainBodyContainer/MainBodyContainer";
import Footer from "../../Footer/Footer";

import MayorOfLondonLogo from "../../../images/logos/logo-mayor-of-london.png";
import GLALogo from "../../../images/logos/logo-gla.png";
import BarkingDagenhamLogo from "../../../images/logos/logo-barking-dagenham.svg";
import DWPLogo from "../../../images/logos/logo-dwp.jpg";
import SSELogo from "../../../images/logos/logo-sse.png";
import HighfieldLogo from "../../../images/logos/logo-highfields.png";
import ShpresaLogo from "../../../images/logos/logo-shpresa.png";
import NewhamCollegeLogo from "../../../images/logos/logo-ncl.png";
import DisabilityConfidentLogo from "../../../images/logos/logo-disability-confident.png";
import FutureYouthZoneLogo from "../../../images/logos/logo-future-youth-zone.jpg";

import "./Partnerships.css";

class Partnerships extends Component {
  partnershipStats = [
    { value: "750+", label: "Beneficiaries Reached", highlight: true },
    { value: "10+", label: "Active Partners" },
    { value: "6", label: "London Boroughs" },
  ];

  strategicPartners = [
    {
      id: "gla",
      name: "Greater London Authority",
      type: "Strategic Funder",
      logo: MayorOfLondonLogo,
      website: "https://www.london.gov.uk/",
      description:
        "Funding community outreach, ESOL programmes, and vocational training through Skills for Londoners.",
      programmes: [
        "Skills for Londoners",
        "Inclusive Talent Strategy",
        "Community Outreach",
      ],
      yearsPartnership: "2024-2025",
    },
    {
      id: "barking-dagenham",
      name: "Barking & Dagenham Council",
      type: "Local Authority Partner",
      logo: BarkingDagenhamLogo,
      website: "https://www.lbbd.gov.uk/",
      description:
        "NCIL-funded youth programmes including our flagship coding camps for young people.",
      programmes: [
        "Young People Coding & AI Camp",
        "Community Outreach",
        "Family Support",
      ],
      yearsPartnership: "2025-2026",
    },
    {
      id: "dwp",
      name: "European Social Fund Agency",
      type: "Government Contract",
      logo: DWPLogo,
      website:
        "https://www.gov.uk/government/organisations/department-for-work-pensions",
      description:
        "Employment Plus contract providing employment support and business upskilling across East London.",
      programmes: ["Employment Plus Contract (2017-2018)"],
      yearsPartnership: "2017-2018",
    },
  ];

  deliveryPartners = [
    {
      id: "newham-college",
      name: "Newham College",
      type: "Educational Partner",
      logo: NewhamCollegeLogo,
      website: "https://www.newham.ac.uk/",
      description:
        "Joint delivery of ESOL and Functional Skills qualifications with learner progression pathways.",
      collaboration: "Qualification delivery & learner progression",
    },
    {
      id: "highfield",
      name: "Highfield Awarding Body",
      type: "Accreditation Partner",
      logo: HighfieldLogo,
      website: "https://www.highfieldqualifications.com/",
      description:
        "Ofqual-regulated vocational qualifications in Customer Service, Health & Safety, and Business Admin.",
      collaboration: "Qualification accreditation",
    },
    {
      id: "sse",
      name: "School for Social Entrepreneurs",
      type: "Capacity Building",
      logo: SSELogo,
      website: "https://www.the-sse.org/",
      description:
        "Supporting APT's organisational development and strategic growth as a CIC.",
      collaboration: "Organisational development",
    },
    {
      id: "shpresa",
      name: "Shpresa Programme",
      type: "Community Partner",
      logo: ShpresaLogo,
      website: "https://www.shpresaprogramme.org/",
      description:
        "Collaborative outreach and support for Albanian-speaking communities across London.",
      collaboration: "Community outreach & cultural support",
    },
    {
      id: "barking-future-youth-zone",
      name: "Barking Future Youth Zone",
      type: "Delivery Partner",
      logo: FutureYouthZoneLogo,
      website: "https://www.futureyouthzone.org/",
      description:
        "Providing venue space for APT's Youth Coding & AI programme, inspiring young people through technology and digital skills.",
      collaboration: "Venue delivery & youth engagement",
    },
  ];

  communityPartners = [
    {
      id: "newham-law",
      name: "Newham Law Centre",
      focus:
        "Legal advice referrals for immigration, housing, and welfare rights",
      website: "https://www.newhamlawcentre.org/",
    },
    {
      id: "citizens-advice",
      name: "Citizens Advice",
      focus: "Benefits advice and advocacy support pathways",
      website: "https://www.citizensadvice.org.uk/",
    },
    {
      id: "shelter",
      name: "Shelter",
      focus: "Housing advocacy and homelessness prevention referrals",
      website: "https://england.shelter.org.uk/",
    },
    {
      id: "refugee-council",
      name: "Refugee Council",
      focus: "Specialist refugee and asylum seeker support coordination",
      website: "https://www.refugeecouncil.org.uk/",
    },
    {
      id: "job-centres",
      name: "Local Job Centres",
      focus: "Employment support referrals and job seeker engagement",
      website: "https://www.gov.uk/contact-jobcentre-plus",
    },
    {
      id: "integration-hubs",
      name: "Integration Hubs",
      focus: "Community integration and asylum seeker settlement support",
      website: null,
    },
  ];

  certifications = [
    {
      id: "disability-confident",
      name: "Disability Confident Employer",
      logo: DisabilityConfidentLogo,
      description: "Committed to employing and supporting disabled people",
    },
    {
      id: "cic",
      name: "Community Interest Company",
      logo: null,
      description: "Profits reinvested for community benefit",
    },
    {
      id: "highfield-centre",
      name: "Highfield Approved Centre",
      logo: HighfieldLogo,
      description: "Ofqual-regulated qualifications",
    },
  ];

  testimonials = [
    {
      id: "testimonial-1",
      quote:
        "APT's community-first approach and proven track record made them an ideal partner for our Skills for Londoners programme. Their reach into underserved communities is exceptional.",
      author: "GLA Skills Team",
      role: "Programme Commissioner",
    },
    {
      id: "testimonial-2",
      quote:
        "The referral pathway with APT has transformed how we support Albanian-speaking families. Their cultural understanding and community trust is invaluable.",
      author: "Shpresa Programme",
      role: "Community Partner",
    },
  ];

  render() {
    return (
      <div>
        <Navbar />
        <div>
          <MainBodyContainer heading={"Our Partnerships"}>
            <div className="partnerships-hero">
              <div className="hero-content">
                <h2 className="hero-title animate__animated animate__fadeInUp">
                  Building Stronger Communities Together
                </h2>
                <p className="hero-subtitle animate__animated animate__fadeInUp">
                  Our partnerships with funders, delivery partners, and
                  community organisations enable us to reach those who need
                  support most and deliver sustainable community impact.
                </p>
              </div>
              <div className="partnership-stats-grid">
                {this.partnershipStats.map((stat) => (
                  <div
                    key={stat.label}
                    className={`stat-item ${stat.highlight ? "stat-highlight" : ""}`}
                  >
                    <div className="stat-value">{stat.value}</div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="trust-badges-section">
              <p className="trust-badges-label">Trusted & Accredited</p>
              <div className="trust-badges-strip">
                {this.certifications.map((cert) => (
                  <div key={cert.id} className="trust-badge">
                    {cert.logo ? (
                      <img
                        src={cert.logo}
                        alt={cert.name}
                        className="badge-logo"
                      />
                    ) : (
                      <div className="badge-placeholder">
                        <span className="badge-icon">🏛️</span>
                      </div>
                    )}
                    <span className="badge-name">{cert.name}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="strategic-partners-section">
              <div className="section-intro">
                <h2 className="section-header">Strategic Partners & Funders</h2>
                <p className="section-description">
                  Major funders and commissioners who trust APT to deliver
                  community programmes at scale.
                </p>
              </div>
              <div className="strategic-grid">
                {this.strategicPartners.map((partner) => (
                  <div key={partner.id} className="strategic-card">
                    <div className="partner-logo-container">
                      <img
                        src={partner.logo}
                        alt={partner.name}
                        className="partner-logo"
                      />
                    </div>
                    <div className="partner-badge">{partner.type}</div>
                    <h3 className="partner-name">{partner.name}</h3>
                    <span className="partnership-years">
                      {partner.yearsPartnership}
                    </span>
                    <p className="partner-description">{partner.description}</p>
                    <div className="partner-programmes">
                      <h4>Programmes:</h4>
                      <ul>
                        {partner.programmes.map((prog) => (
                          <li key={prog}>{prog}</li>
                        ))}
                      </ul>
                    </div>
                    {partner.website && (
                      <a
                        href={partner.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="partner-website-link"
                      >
                        Visit Partner →
                      </a>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="delivery-partners-section">
              <div className="section-intro">
                <h2 className="section-header">
                  Delivery & Accreditation Partners
                </h2>
                <p className="section-description">
                  Organisations we work with to ensure quality qualifications
                  and sustainable learner outcomes.
                </p>
              </div>
              <div className="delivery-grid">
                {this.deliveryPartners.map((partner) => (
                  <div key={partner.id} className="delivery-card">
                    <div className="delivery-card-header">
                      {partner.logo ? (
                        <div className="delivery-logo-container">
                          <img
                            src={partner.logo}
                            alt={partner.name}
                            className="delivery-logo"
                          />
                        </div>
                      ) : (
                        <div className="delivery-logo-placeholder">
                          <span>{partner.name.charAt(0)}</span>
                        </div>
                      )}
                      <span className="delivery-type">{partner.type}</span>
                    </div>
                    <h3 className="delivery-name">{partner.name}</h3>
                    <p className="delivery-description">
                      {partner.description}
                    </p>
                    <div className="delivery-footer">
                      <p className="collaboration-type">
                        <strong>Collaboration:</strong> {partner.collaboration}
                      </p>
                      {partner.website && (
                        <a
                          href={partner.website}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="delivery-link"
                        >
                          Learn More →
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="community-partners-section">
              <div className="section-intro">
                <h2 className="section-header">
                  Community & Referral Partners
                </h2>
                <p className="section-description">
                  Organisations we refer to and receive referrals from, ensuring
                  holistic support for our community.
                </p>
              </div>
              <div className="community-grid">
                {this.communityPartners.map((partner) => (
                  <div key={partner.id} className="community-card">
                    <h4 className="community-name">{partner.name}</h4>
                    <p className="community-focus">{partner.focus}</p>
                    {partner.website && (
                      <a
                        href={partner.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="community-link"
                      >
                        Visit →
                      </a>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="testimonials-section">
              <h2 className="testimonials-header">What Partners Say</h2>
              <div className="testimonials-grid">
                {this.testimonials.map((testimonial) => (
                  <div key={testimonial.id} className="testimonial-card">
                    <blockquote className="testimonial-quote">
                      "{testimonial.quote}"
                    </blockquote>
                    <div className="testimonial-author">
                      <strong>{testimonial.author}</strong>
                      <span>{testimonial.role}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="partner-cta-section">
              <h2>Partner With APT</h2>
              <p>
                We're always looking for new partnerships - whether you're a
                funder, employer, delivery partner, or community organisation.
                Together we can reach more people and create greater impact.
              </p>
              <div className="partnership-types">
                <div className="partnership-type">
                  <div className="partnership-icon">🏛️</div>
                  <h3>Funders & Commissioners</h3>
                  <p>
                    Looking to commission community skills or employment
                    programmes in East London? We have proven delivery capacity
                    and strong community relationships.
                  </p>
                </div>
                <div className="partnership-type">
                  <div className="partnership-icon">💼</div>
                  <h3>Employers</h3>
                  <p>
                    Want to access diverse, trained talent? Partner with us for
                    recruitment, work placements, or corporate volunteering
                    opportunities.
                  </p>
                </div>
                <div className="partnership-type">
                  <div className="partnership-icon">🤝</div>
                  <h3>Community Organisations</h3>
                  <p>
                    Working with similar communities? Let's build referral
                    pathways and collaborate on outreach to ensure no one falls
                    through the gaps.
                  </p>
                </div>
              </div>
              <div className="cta-buttons">
                <Link
                  to="/contact?inquiry=partnership"
                  className="cta-button primary"
                >
                  Start a Partnership Conversation
                </Link>
                <Link to="/about/our-impact" className="cta-button secondary">
                  View Our Impact Data
                </Link>
              </div>
            </div>
          </MainBodyContainer>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Partnerships;
